export const CURRENT_LOGGED_IN_USER_ID_LOCALFORAGE_KEY = "current_logged_in_user_id";
export const LAST_LOGGED_IN_USER_ID_LOCALFORAGE_KEY = "last_logged_in_user_id";
export const LOGGED_IN_USER_ID_LOCALFORAGE_TABLE = "logged_in_users";